(function (define) {
	'use strict';

	define(function (require) {

		var interceptor;
		var storage;

		interceptor = require('rest/interceptor');
		storage = require('store')

		/**
		 * Authenticates the request using JWT Authentication
		 *
		 * @param {Client} [client] client to wrap
		 * @param {Object} config
		 *
		 * @returns {Client}
		 */
		return interceptor({
			request: function (request, config) {
				var token, headers;

				token = storage.get('token');
				headers = request.headers || (request.headers = {});

				if ( token !== null && token !== 'undefined') {
					headers.Authorization = `Bearer ${token}`;
				}

		    	return request;
			},
			response: function (response) {
				if (response.status && response.status.code == 401) {
					storage.remove('token');

					window.router.push({name:'auth.login'});
				}

				if (response.status && response.status.code == 403) {
					storage.remove('token');

					window.router.push({name:'auth.login'});
				}

				if (response.status && response.status.code == 500) {
					alert('API error');
				}
				
				if (response.headers && response.headers.Authorization) {
					storage.set('token', response.headers.Authorization)
				}
				if (response.entity && response.entity.token && response.entity.token.length > 10) {
					storage.set('token', response.entity.token);
				}
				return response;
			}
		});

	});

}(
	typeof define === 'function' && define.amd ? define : function (factory) { module.exports = factory(require); }
	// Boilerplate for AMD and Node
));